import {ChangeDetectionStrategy, Component, DestroyRef, inject, Input, OnInit} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {ToastService} from '../../../../services/layout/toast.service';
import {MaterialModule} from "../../../../material.module";

import {ClientService} from "../../../../services/auth/client.service";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {LlmModelsService} from "../../../../services/ai/llm-models.service";
import {
    buildLlmModelOptions,
    filterLlmModelOptions,
    LlmModelOption,
    modelValueToLabel
} from "../../../../utils/llm-models.utils";

@Component({
  selector: 'app-general-settings',
  templateUrl: './general-settings.component.html',
  styleUrls: ['./general-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MaterialModule, ReactiveFormsModule]
})
export class GeneralSettingsComponent implements OnInit {
    private snackBar = inject(ToastService);
    clientService = inject(ClientService);
    private destroyRef = inject(DestroyRef);
    private llmModelsService = inject(LlmModelsService);


  @Input() settingsForm: FormGroup;

    modelOptions: LlmModelOption[] = buildLlmModelOptions(null);
    filteredClassificationModelOptions: LlmModelOption[] = this.modelOptions;

    displayModelValue = (value: string): string => modelValueToLabel(value, this.modelOptions);

  ngOnInit(): void {
    // Ensure the settingsForm has all necessary controls
    if (!this.settingsForm) {
      throw new Error('settingsForm Input is required for GeneralSettingsComponent');
    }

      const classificationModelControl = this.settingsForm.get('classificationModel');
      if (classificationModelControl) {
          this.filteredClassificationModelOptions = filterLlmModelOptions(this.modelOptions, classificationModelControl.value);
          classificationModelControl.valueChanges
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe(value => {
                  this.filteredClassificationModelOptions = filterLlmModelOptions(this.modelOptions, value);
              });
      }

      this.llmModelsService.getModels()
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((resp) => {
              this.modelOptions = buildLlmModelOptions(resp);
              this.filteredClassificationModelOptions =
                  filterLlmModelOptions(this.modelOptions, classificationModelControl?.value);
          });
  }
}
